import { ContributorPaymentLogModel } from './contributor.payment.log.model';

export class PagedContributorPaymentLogDetail {
    currentPage: number;
    totalPages: number;
    pageSize: number;
    totalCount: number;
    items: Array<ContributorPaymentLogModel>;

    constructor() {
        this.items = new Array<ContributorPaymentLogModel>();
    }
}
